import Navigation from "@/components/site/Navigation";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import MeetMonica from "@/components/site/MeetMonica";
import Testimonials from "@/components/site/Testimonials";
import Booking from "@/components/site/Booking";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" style={{ background: "var(--bg-primary)" }}>
      <Navigation />
      <Hero />
      <About />
      <Services />
      <MeetMonica />
      <Testimonials />
      <Booking />
      <FAQ />
      <Footer />
    </main>
  );
}
